import { useCallback } from 'react';
import { useModal } from '@pelando/components';
import { LockScrollGlobally } from '@/presentation/styles/global';
import { useTranslation } from '@/presentation/hooks/useTranslation';

import {
  CheckAnimation,
  Container,
  Title,
  Subtitle,
  modalStyle,
  CheckAnimationWrapper,
} from './style';

type CashbackSuccessModalProps = {
  cashbackPercentage: number;
};

export const CashbackSuccessModal = ({
  cashbackPercentage = 0,
}: CashbackSuccessModalProps) => {
  const { t } = useTranslation('common');

  return (
    <Container>
      <CheckAnimationWrapper>
        <CheckAnimation />
      </CheckAnimationWrapper>
      <Title>
        {t('cashback-success-modal-title', `${cashbackPercentage}%`)}
      </Title>
      <Subtitle>{t('cashback-success-modal-subtitle')}</Subtitle>
    </Container>
  );
};

export const useCashbackSuccessModal = () => {
  const { showModal } = useModal();

  const showSuccessModal = useCallback(
    (cashbackPercentage: number) => {
      showModal(
        <>
          <CashbackSuccessModal cashbackPercentage={cashbackPercentage} />
          <LockScrollGlobally lock />
        </>,
        {
          style: modalStyle,
        }
      );
    },
    [showModal]
  );

  return {
    showSuccessModal,
  };
};
